module.exports = __webpack_public_path__ + "img/tooltip_01-vallone-noya-duo-black.f30b4ff4.jpg";